export const DOT_SIZE = 8;

export const LEGEND_SEPARATOR_HEIGHT = 9;
